import React from "react";
import { ManageFundingsContainer } from "../../../containers";

const ManageFundings = (props) => {
  return <ManageFundingsContainer {...props} />;
};

export default ManageFundings;
